import { Injectable, inject } from '@angular/core';
import { NEVER, Observable, distinctUntilChanged, switchMap, take, timeout } from 'rxjs';
import { OnlineStateService } from '@services/online-state.service';

@Injectable({providedIn: 'root'})
export class PageLoadService {
  private readonly onlineState = inject(OnlineStateService);

  public static readonly REQUEST_TIMEOUT_MS = 15000;

  public read<T>(request: Observable<T>): Observable<T> {
    return this.onlineState.isOffline$.pipe(
      distinctUntilChanged(),
      switchMap(isOffline => isOffline ? NEVER : request.pipe(timeout(PageLoadService.REQUEST_TIMEOUT_MS))),
      take(1),
    );
  }
}
